
<textarea
class="area"
[rows]="rows"
[placeholder]="placeholder || ''"
[title]="placeholder || ''"
[(ngModel)]="value"
(input)="updateValue($any($event.target).value)"
[attr.disabled]="disabled ? '' : null">
</textarea>
